import { useTranslation } from "react-i18next";
import { ArrowDownLeft, ArrowUpRight } from "lucide-react";
import { cn } from "@/lib/utils";
import { formatMoneyOrEmpty } from "@/lib/money";

export function SettlementLineAmountCell({
  cents,
  currency,
  direction,
}: {
  cents: number | null;
  currency: string;
  direction?: "incoming" | "outgoing";
}) {
  const { t } = useTranslation("payments");
  const emptyLabel = t("shared.emptyCell");

  if (cents === null || cents === 0) {
    return <span className="text-surface-400">{emptyLabel}</span>;
  }

  const amount = (
    <span className="tabular-nums text-surface-900">
      {formatMoneyOrEmpty(cents, currency, emptyLabel)}
    </span>
  );

  if (!direction) {
    return amount;
  }

  const directionLabel =
    direction === "outgoing"
      ? t("settlements.detail.moneyDirectionOutgoing")
      : t("settlements.detail.moneyDirectionIncoming");

  return (
    <div className="flex items-center gap-1.5">
      {direction === "outgoing" ? (
        <ArrowUpRight
          className={cn("h-3.5 w-3.5 shrink-0 text-error-600")}
          aria-label={directionLabel}
        />
      ) : (
        <ArrowDownLeft
          className={cn("h-3.5 w-3.5 shrink-0 text-success-600")}
          aria-label={directionLabel}
        />
      )}
      {amount}
    </div>
  );
}
